// Prevent Shopify App Script Execution
function normalizeOption(s) {
  return s
    ? s.toString().toLowerCase().replace(/\s+/g, '')
    : '';
}

function toggleFilterButtonState(){}

function getSwatchColor(label) {
  // 1) Om det är “Flerfärgad” (på det språk butiken visar)
  if (label === window.texts.multicolorLabel) {
    // konstant gradient
    return 'conic-gradient(#FF0000, #FFA500, #FFFF00, #008000, #0000FF, #4B0082, #EE82EE)';
  }
  // 2) Annars vanlig lookup
  const slug = normalizeOption(label);
  const col  = window.normalizedColorSwatches[slug];
  return col || '#e6e6e6';
}

let esify_app_disabled = document.querySelector(
  "#shopify-block-Aajk0TllTV2lJZTdoT__15683396631634586217"
);
if (esify_app_disabled) esify_app_disabled.remove();
// Data Size Frame Element

// Global variabel för aktiva filter: nyckeln är filter‐namnet och värdet är en array med valda värden.
let activeFilters = {};
window.selectedFilters = {};

// ─── Auto-detect combined locale + market prefix ─────────────────────
(function () {
  // Matchar “/de”, “/en-eu”, “/sv-eup” …
  const m = window.location.pathname.match(/^\/([a-z]{2}(?:-[a-z0-9]+)?)\//i);

  // Prefix som måste för-användas i interna fetch-anrop
  window.localeMarketPrefix = m ? `/${m[1]}` : "";

  // Tvåbokstavskoden för ?locale= / &lang=
  // Root-path (svenska + SEK) ⇒ hårdkodat "sv"
  window.shopLocale = m ? m[1].slice(0, 2) : "sv";
})();

// Läs ut den valuta vi vill be Shopify om
function getCurrentCurrency() {
  // Först: kolla om Currency-picker satt cookie
  var m = document.cookie.match(/(?:^|; )cart_currency=([^;]+)/);
  if (m) return m[1];
  // Annars: fallback på den Liquid-injicerade
  return window.presentmentCurrency || 'SEK';
}
var currency = getCurrentCurrency();

;(function(){
  var locale = (window.shopLocale || 'sv').replace('_','-');
  Shopify.formatMoney = function(cents, format){
    var value = (typeof cents==='number') ? cents/100 : parseFloat(cents)/100;
    var precision = (typeof format==='string' && format.includes('amount_no_decimals')) ? 0 : 2;
    try {
      return new Intl.NumberFormat(locale, {
        style:                 'currency',
        currency:              currency,
        minimumFractionDigits: precision,
        maximumFractionDigits: precision
      }).format(value);
    } catch(e) {
      return value.toFixed(precision) + ' ' + currency;
    }
  };
})();


function buildBaseQuery(element) {
  // Skapar en basquery utifrån elementets data‑attribut
  return `?q=${element.dataset.size}&options%5Bprefix%5D=last&filter.v.price.gte=&filter.v.price.lte=&filter.p.m.custom.format=${encodeURIComponent(element.dataset.orientation)}&filter.p.m.custom.typ_av_produkt=${encodeURIComponent(element.dataset.type)}&sort_by=relevance`;
}


function updateActiveArticleQuery() {
  let activeArticle = document.querySelector(".item.active");
  if (!activeArticle) return;

  // Om basqueryn inte redan är sparad, bygg den med din buildBaseQuery()-funktion.
  if (!activeArticle.dataset.baseQuery) {
    activeArticle.dataset.baseQuery = buildBaseQuery(activeArticle);
  }
  let baseQuery = activeArticle.dataset.baseQuery;

  // Hämta söktermen från dataset (om användaren skrivit något) 
  // och förbered den för att läggas till q‑parametern med ett plus-tecken.
  let searchTerm = activeArticle.dataset.searchTerm || "";
  let searchPart = "";
  if (searchTerm) {
    searchPart = `+${encodeURIComponent(searchTerm)}`;
  }

  // Vi utgår från att baseQuery börjar med ?q=... 
  // Använd endast den första delen av q‑parametern (basstorleken) och lägg sedan till söktermen.
  let qMatch = baseQuery.match(/^\?q=([^&]+)/);
  let newQuery = "";
  if (qMatch) {
    // Ta ut endast storleksdelen (före det eventuella plus-tecknet)
    let baseSize = qMatch[1].split("+")[0];
    // Sätt q‑parametern till storleken + söktermen och behåll resten av baseQueryn.
    newQuery = `?q=${baseSize}${searchPart}` + baseQuery.substring(qMatch[0].length);
  } else {
    newQuery = baseQuery;
  }

  // Lägg till varje aktiv filter (alla värden för varje filter läggs ihop med ett kommatecken)
  for (let filterName in window.selectedFilters) {
    if (window.selectedFilters[filterName] && window.selectedFilters[filterName].length > 0) {
      newQuery += `&${encodeURIComponent(filterName)}=${window.selectedFilters[filterName].join(",")}`;
    }
  }

  // Uppdatera activeArticle dataset med den nya query-strängen
  activeArticle.dataset.query = newQuery;
}



// Går igenom alla element med klassen .filterItem och lägger till "active" om
// deras data‑name och data‑value matchar vad som finns i activeFilters.
function updateFilterItemClasses() {
  document.querySelectorAll(".filterOptionsContainer .filterItem").forEach(item => {
    const key = item.dataset.name;
    const val = item.dataset.value;
    if (activeFilters[key] && activeFilters[key].indexOf(val) !== -1) {
      item.classList.add("active");
    } else {
      item.classList.remove("active");
    }
  });
}

function hideLegacyFramePicker() {
  const el = document.querySelector('.picker_frame');
  if (el) {
    el.classList.remove('active');
    el.style.display = 'none';
  }
}
document.addEventListener('DOMContentLoaded', hideLegacyFramePicker);


function debounce(func, delay) {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), delay);
  };
}


let Frame_Set = [
  [
    {
      size: "50x70",
      filter: "30x40cm / 12x16″",
      orientation: "gid://shopify/Metaobject/137427681626",
      type: "gid://shopify/Metaobject/137426436442",
      position: "0",
      index: "0",
      top: "18.5%",
      left: "32%",
    },
    {
      size: "50x70",
      filter: "30x40cm / 12x16″",
      orientation: "gid://shopify/Metaobject/137427681626",
      type: "gid://shopify/Metaobject/137426436442",
      position: "1",
      index: "1",
      top: "18.5%",
      left: "51%",
    },
  ],
  [
    {
      size: "70x100",
      filter: "70x100cm / 28x40″",
      orientation: "gid://shopify/Metaobject/137427681626",
      type: "gid://shopify/Metaobject/137426436442",
      position: "0",
      index: "0",
      top: "12.5%",
      left: "25.8%",
    },
    {
      size: "70x100",
      filter: "70x100cm / 28x40″",
      orientation: "gid://shopify/Metaobject/137427681626",
      type: "gid://shopify/Metaobject/137426436442",
      position: "1",
      index: "1",
      top: "12.5%",
      left: "51%",
    },
  ],
  [
    {
      size: "50x70",
      filter: "30x40cm / 12x16″",
      orientation: "gid://shopify/Metaobject/137427681626",
      type: "gid://shopify/Metaobject/137426436442",
      position: "0",
      index: "0",
      top: "18.5%",
      left: "22%",
    },
    {
      size: "50x70",
      filter: "30x40cm / 12x16″",
      orientation: "gid://shopify/Metaobject/137427681626",
      type: "gid://shopify/Metaobject/137426436442",
      position: "1",
      index: "1",
      top: "18.5%",
      left: "41%",
    },
    {
      size: "50x70",
      filter: "30x40cm / 12x16″",
      orientation: "gid://shopify/Metaobject/137427681626",
      type: "gid://shopify/Metaobject/137426436442",
      position: "2",
      index: "2",
      top: "18.5%",
      left: "60%",
    },
  ],
  [
    {
      size: "50x70",
      filter: "30x40cm / 12x16″",
      orientation: "gid://shopify/Metaobject/137427681626",
      type: "gid://shopify/Metaobject/137426436442",
      position: "0",
      index: "0",
      top: "21.2%",
      left: "19%",
    },
    {
      size: "70x100",
      filter: "70x100cm / 28x40″",
      orientation: "gid://shopify/Metaobject/137427681626",
      type: "gid://shopify/Metaobject/137426436442",
      position: "1",
      index: "1",
      top: "12.5%",
      left: "38.2%",
    },
    {
      size: "50x70",
      filter: "30x40cm / 12x16″",
      orientation: "gid://shopify/Metaobject/137427681626",
      type: "gid://shopify/Metaobject/137426436442",
      position: "2",
      index: "2",
      top: "21.2%",
      left: "63.8%",
    },
  ],
  [
    {
      size: "30x40",
      filter: "30x40cm / 12x16″",
      orientation: "gid://shopify/Metaobject/137427681626",
      type: "gid://shopify/Metaobject/137426436442",
      position: "0",
      index: "0",
      top: "12.5%",
      left: "38%",
    },
    {
      size: "30x40",
      filter: "30x40cm / 12x16″",
      orientation: "gid://shopify/Metaobject/137427681626",
      type: "gid://shopify/Metaobject/137426436442",
      position: "1",
      index: "1",
      top: "12.5%",
      left: "51%",
    },
    {
      size: "30x40",
      filter: "30x40cm / 12x16″",
      orientation: "gid://shopify/Metaobject/137427681626",
      type: "gid://shopify/Metaobject/137426436442",
      position: "2",
      index: "2",
      top: "39.5%",
      left: "51%",
    },
    {
      size: "30x40",
      filter: "30x40cm / 12x16″",
      orientation: "gid://shopify/Metaobject/137427681626",
      type: "gid://shopify/Metaobject/137426436442",
      position: "3",
      index: "3",
      top: "39.5%",
      left: "38%",
    },
  ],
  [
    {
      size: "30x40",
      filter: "30x40cm / 12x16″",
      orientation: "gid://shopify/Metaobject/137427681626",
      type: "gid://shopify/Metaobject/137426436442",
      position: "0",
      index: "0",
      top: "26.4%",
      left: "18.9%",
    },
    {
      size: "50x70",
      filter: "30x40cm / 12x16″",
      orientation: "gid://shopify/Metaobject/137427681626",
      type: "gid://shopify/Metaobject/137426436442",
      position: "1",
      index: "1",
      top: "18.5%",
      left: "31.8%",
    },
    {
      size: "50x70",
      filter: "30x40cm / 12x16″",
      orientation: "gid://shopify/Metaobject/137427681626",
      type: "gid://shopify/Metaobject/137426436442",
      position: "2",
      index: "2",
      top: "18.5%",
      left: "51%",
    },
    {
      size: "30x40",
      filter: "30x40cm / 12x16″",
      orientation: "gid://shopify/Metaobject/137427681626",
      type: "gid://shopify/Metaobject/137426436442",
      position: "3",
      index: "3",
      top: "26.4%",
      left: "70%",
    },
  ],
  [
    {
      size: "50x70",
      filter: "30x40cm / 12x16″",
      positionOriantation: "landscape",
      orientation: "gid://shopify/Metaobject/137427648858",
      type: "gid://shopify/Metaobject/137426436442",
      position: "0",
      index: "0",
      top: "4.5%",
      left: "28.7%",
    },
    {
      size: "70x100",
      filter: "70x100cm / 28x40″",
      orientation: "gid://shopify/Metaobject/137427681626",
      type: "gid://shopify/Metaobject/137426436442",
      position: "1",
      index: "1",
      top: "4.5%",
      left: "53.9%",
    },
    {
      size: "30x40",
      filter: "30x40cm / 12x16″",
      orientation: "gid://shopify/Metaobject/137427681626",
      type: "gid://shopify/Metaobject/137426436442",
      position: "2",
      index: "2",
      top: "35.6%",
      left: "22.9%",
    },
    {
      size: "50x70",
      filter: "30x40cm / 12x16″",
      orientation: "gid://shopify/Metaobject/137427681626",
      type: "gid://shopify/Metaobject/137426436442",
      position: "3",
      index: "3",
      top: "35.6%",
      left: "35.3%",
    },
  ],
  [
    {
      size: "50x70",
      filter: "30x40cm / 12x16″",
      orientation: "gid://shopify/Metaobject/137427681626",
      type: "gid://shopify/Metaobject/137426436442",
      position: "0",
      index: "0",
      top: "8.5%",
      left: "32%",
    },
    {
      size: "50x50",
      filter: "50x50cm / 12x12″",
      orientation: "gid://shopify/Metaobject/137427681626",
      type: "gid://shopify/Metaobject/137426436442",
      position: "1",
      index: "1",
      top: "8.5%",
      left: "50%",
    },
    {
      size: "30x40",
      filter: "30x40cm / 12x16″",
      orientation: "gid://shopify/Metaobject/137427681626",
      type: "gid://shopify/Metaobject/137426436442",
      position: "2",
      index: "2",
      top: "39.6%",
      left: "50.4%",
    },
    {
      size: "13x18",
      filter: "13x18cm / 5x7″",
      orientation: "gid://shopify/Metaobject/137427681626",
      type: "gid://shopify/Metaobject/137426436442",
      position: "3",
      index: "3",
      top: "39.6%",
      left: "62%",
    },
  ],
  [
    {
      size: "21x30",
      filter: "21x29.7 cm / 8x12″",
      orientation: "gid://shopify/Metaobject/137427681626",
      type: "gid://shopify/Metaobject/137426436442",
      position: "0",
      index: "0",
      top: "26.7%",
      left: "17.5%",
    },
    {
      size: "30x40",
      filter: "30x40cm / 12x16″",
      orientation: "gid://shopify/Metaobject/137427681626",
      type: "gid://shopify/Metaobject/137426436442",
      position: "1",
      index: "1",
      top: "10.5%",
      left: "27%",
    },
    {
      size: "30x40",
      filter: "30x40cm / 12x16″",
      orientation: "gid://shopify/Metaobject/137427681626",
      type: "gid://shopify/Metaobject/137426436442",
      position: "2",
      index: "2",
      top: "37%",
      left: "27%",
    },
    {
      size: "70x100",
      filter: "70x100cm / 28x40″",
      orientation: "gid://shopify/Metaobject/137427681626",
      type: "gid://shopify/Metaobject/137426436442",
      position: "3",
      index: "3",
      top: "7%",
      left: "39.5%",
    },
    {
      size: "50x70",
      filter: "30x40cm / 12x16″",
      orientation: "gid://shopify/Metaobject/137427681626",
      type: "gid://shopify/Metaobject/137426436442",
      position: "4",
      index: "4",
      top: "16%",
      left: "65%",
    },
  ],
  [
    {
      size: "40x50",
      filter: "40x50cm / 16x20″",
      orientation: "gid://shopify/Metaobject/137427681626",
      type: "gid://shopify/Metaobject/137426436442",
      position: "0",
      index: "0",
      top: "2.4%",
      left: "16.39%",
    },
    {
      size: "70x100",
      filter: "70x100cm / 28x40″",
      orientation: "gid://shopify/Metaobject/137427681626",
      type: "gid://shopify/Metaobject/137426436442",
      position: "1",
      index: "1",
      top: "0%",
      left: "31.6%",
    },
    {
      size: "50x70",
      filter: "30x40cm / 12x16″",
      orientation: "gid://shopify/Metaobject/137427681626",
      type: "gid://shopify/Metaobject/137426436442",
      position: "2",
      index: "2",
      top: "1.5%",
      left: "56.6%",
    },
    {
      size: "50x70",
      filter: "30x40cm / 12x16″",
      orientation: "gid://shopify/Metaobject/137427681626",
      type: "gid://shopify/Metaobject/137426436442",
      position: "3",
      index: "3",
      top: "34.3%",
      left: "13.3%",
    },
    {
      size: "30x40",
      filter: "30x40cm / 12x16″",
      positionOriantation: "landscape",
      orientation: "gid://shopify/Metaobject/137427648858",
      type: "gid://shopify/Metaobject/137426436442",
      position: "4",
      index: "4",
      top: "58.9%",
      left: "31.6%",
    },
    {
      size: "21x30",
      filter: "21x29.7 cm / 8x12″",
      orientation: "gid://shopify/Metaobject/137427681626",
      type: "gid://shopify/Metaobject/137426436442",
      position: "5",
      index: "5",
      top: "58.8%",
      left: "47.6%",
    },
    {
      size: "40x50",
      filter: "40x50cm / 16x20″",
      orientation: "gid://shopify/Metaobject/137427681626",
      type: "gid://shopify/Metaobject/137426436442",
      position: "6",
      index: "6",
      top: "43%",
      left: "56.6%",
    },
    {
      size: "30x40",
      filter: "30x40cm / 12x16″",
      orientation: "gid://shopify/Metaobject/137427681626",
      type: "gid://shopify/Metaobject/137426436442",
      position: "7",
      index: "7",
      top: "43%",
      left: "71.99%",
    },
  ],
];

// Global Functions and Variables
let slides_container = document.querySelectorAll(".slide_container");
let siteBasketCart = document.querySelector(".siteBasket");
let pickMotifs = document.querySelector("#pickMotifs");
let zoomElement = document.querySelector("#zoomElement");
let collection_articles = document.querySelector(".collection_articles");
let article_frame_picked_position;

// On click Product Article
let beforeChosenOkText = document.querySelector(".beforeChosenOkText");
let chosenArticlesBasket = document.querySelector(".basket .chosenArticles");
let basket_for_frame = document.querySelector(".basket_for_frame");
let priceContainerPrice = document.querySelector(
  "#_cf632b71-4ca8-8454-d226-d7677e6220e9"
);
let priceContainerPriceMobile = document.querySelector(".mobileButtonsdfkj");
let priceContainerPrefix = document.querySelector("#priceContainer .prefix");
// change main image global function
function ChangeImage(url) {
  zoomElement.style.backgroundImage = `url(${url})`;
}

// Open Slide
function OpenSlide(slideClass, condition) {
  document.querySelector(`.${slideClass}`).classList.add("active");
  switch (condition) {
    case "welcome":
      if (document.getElementById("welcome")) {
        document.getElementById("welcome").remove();
      }
      slides_container.forEach((container) => {
        if (
          !container.classList.contains(slideClass) &&
          container.classList.contains("active")
        ) {
          container.classList.remove("active");
        }
      });
      break;
    case "filters":
      document.querySelector(".filterPanel .filterButton .show").style.display =
        "none";
      document.querySelector(".filterPanel .filterButton .hide").style.display =
        "inline";
    case "select_wall":
      if (document.getElementById("welcome")) {
        document.getElementById("welcome").remove();
      }
      break;
  }
}

// Close Slide
function CloseSlide(parentClass) {
  document.querySelector(`.${parentClass}`).classList.remove("active");
  switch (parentClass) {
    case "articlePicker":
      if (document.querySelector(".item.active")) {
        document.querySelector(".item.active").classList.remove("active");
      }
      if (document.querySelector(".varaint_selection.active")) {
        document
          .querySelector(".varaint_selection.active")
          .classList.remove("active");
        document
          .querySelector(".product_variant_options_button_back")
          .classList.add("hidden");
      }
      break;
    case "varaint_selection":
      document
        .querySelector(".product_variant_options_button_back")
        .classList.add("hidden");
      break;
    case "filters_container":
      document.querySelector(".filterPanel .filterButton .show").style.display =
        "inline";
      document.querySelector(".filterPanel .filterButton .hide").style.display =
        "none";
    case "framePicker":
      if (document.querySelector(".basket_for_frame .frame")) {
        document.querySelector("#framePicker").classList.add("done");
      }
      break;
  }
}
// Next Slide
function NextSlide(parentClass) {
  if (parentClass === 'articlePicker') {
    // Om vi just låg i marginal-sliden, gör som ovan…
    if (document.querySelector('.varaint_selection.active')) {
      CloseSlide('varaint_selection');
      window.currentHasMargin = false;
      product_article_next_button.classList.remove('hidden');
      return;
    }

    // Ta bort active på nuvarande
    const current = document.querySelector('#draggableContainer .item.active');
    if (current) current.classList.remove('active');

    // Försök aktivera nästa tomma
    const hasEmpty = autoSelectFirstEmptyDraggableItem();
    product_article_next_button.classList.remove('hidden');

    // Om inga tomma kvar → ram-väljaren
    if (!hasEmpty) {
      CloseSlide('articlePicker');
      OpenSlide('framePicker', '');
    }
  } else {
    CloseSlide(parentClass);
    OpenSlide(nextClass || '', '');
  }
}


function toggleFramePicker() {
  const framePicker = document.getElementById("framePicker");
  if (!framePicker) return;
  
  if (framePicker.classList.contains("active")) {
    CloseSlide("framePicker");
  } else {
    // Kommentera ut eller ta bort renderAllFrameOptions om du vill
    // renderAllFrameOptions();
    OpenSlide("framePicker", "");
  }
}



function CartOpen() {
  siteBasketCart.classList.toggle("active");
}
function CloseCart(element) {
  element.parentElement.classList.remove("active");
}

// Color Selection for Background images
let colorSliderElement = document.querySelectorAll(".colorSliderElement");
colorSliderElement.forEach((colorElement) => {
  let colors = colorElement.querySelectorAll(".item .color");
  colors.forEach((color) => {
    color.addEventListener("click", function () {
      ChangeImage(color.getAttribute("data-img"));
      colors.forEach((innerColor) => {
        innerColor.innerHTML = "";
      });
      color.innerHTML = '<i class="fa fa-check"></i>';
    });
  });
});

let backgroundList = document.querySelectorAll(
  ".backgroundList > .item.full > .image.pointer"
);
let backgroundWallSelectionNextButton = document.querySelector(
  ".picker_background .nextStep"
);
let color_picker = document.querySelector(".color_picker");
backgroundList.forEach((background) => {
  background.addEventListener("click", function () {
    backgroundList.forEach((innerBackground) => {
      innerBackground.parentElement.classList.remove("active");
    });
    background.parentElement.classList.add("active");
    ChangeImage(background.getAttribute("data-img"));
    document.getElementById("select_background_element").classList.add("done");
    backgroundWallSelectionNextButton.classList.remove("hidden");
  });
});
color_picker.addEventListener("change", () => {
  if (
    document
      .querySelector("#zoomElement")
      .style.backgroundImage.includes("10-overlay")
  ) {
    document.querySelector("#zoomElement").style.backgroundColor =
      color_picker.value;
    document.querySelector(".customColorcustomize").style.backgroundColor =
      color_picker.value;
  }
});

document
  .getElementById("ContactForm-file-upload")
  .addEventListener("change", async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", "pv0c9yjj11");

    try {
      const response = await fetch(
        "https://api.cloudinary.com/v1_1/devihvdp5/upload",
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await response.json();
      const fileUrl = data;
      ChangeImage(fileUrl.url);
      document.querySelector(".customColorcustomize").dataset.img = fileUrl.url;
      document.querySelector(".customColorcustomize img").src = fileUrl.url;
    } catch (error) {
    }
  });

// Select Grid Picture Set
let gridNextButton = document.querySelector(".picker_frame .nextStep");
let draggableContainer = document.querySelector("#draggableContainer");
let pictureWallList = document.querySelectorAll(
  ".pictureWallList #wallSliderElement .item"
);
pictureWallList.forEach((set, index) => {
  set.addEventListener("click", () => {
    gridNextButton.classList.remove("hidden");
    document.getElementById("select_pictureWall_element").classList.add("done");
    pickMotifs.classList.remove("done");
    if (draggableContainer.classList.contains("hidden")) {
      draggableContainer.classList.remove("hidden");
    }
    draggableContainer.innerHTML = "";
    chosenArticlesBasket.innerHTML = "";
    basket_for_frame.innerHTML = "";
    for (let i = 0; i < Frame_Set[index].length; i++) {
      draggableContainer.insertAdjacentHTML(
        "beforeend",
        `
          <div 
            data-size="${Frame_Set[index][i].size}" 
            data-position="${Frame_Set[index][i].position}"
            data-item-index="${Frame_Set[index][i].index}" 
            style="top: ${Frame_Set[index][i].top}; left: ${
          Frame_Set[index][i].left
        };"
            class="item ${
              Frame_Set[index][i].positionOriantation == "landscape" ? "landscape" : ""
            }"
            data-orientation="${Frame_Set[index][i].orientation}"
            data-type="${Frame_Set[index][i].type}"
            onclick="ArticalPicker(this)"
          ><div class="inner">
          ${Frame_Set[index][i].size}
          </div> <!----></div>
      `
      );
      basket_for_frame.insertAdjacentHTML(
        "beforeend",
        `
        <div class="frame hidden" data-size="${Frame_Set[index][i].size}"  data-position="${Frame_Set[index][i].position}"
            data-item-index="${Frame_Set[index][i].index}">
        </div>`
      );
      chosenArticlesBasket.insertAdjacentHTML(
        "beforeend",
        `
        <div class="article hidden" data-position="${Frame_Set[index][i].position}"
            data-item-index="${Frame_Set[index][i].index}" data-size="${Frame_Set[index][i].size}" >
          </div>
      `
      );
    }
  });
});
class Draggable {
  constructor(containerSelector) {
    this.container = document.querySelector(containerSelector);
    this.parent = this.container.parentElement;
    this.isTouchDevice = "ontouchstart" in window;
    this.initDrag();
  }

  initDrag() {
    let startX,
      startY,
      offsetX = 0,
      offsetY = 0;
    let isDragging = false;

    const startDrag = (event) => {
      if (event.target.closest(".item")) return; // Allow clicks on items

      event.preventDefault();
      isDragging = true;

      let clientX = event.touches ? event.touches[0].clientX : event.clientX;
      let clientY = event.touches ? event.touches[0].clientY : event.clientY;

      startX = clientX;
      startY = clientY;
      offsetX = parseFloat(this.container.dataset.x) || 0;
      offsetY = parseFloat(this.container.dataset.y) || 0;

      if (this.isTouchDevice) {
        document.addEventListener("touchmove", moveDrag, { passive: false });
        document.addEventListener("touchend", stopDrag);
      } else {
        document.addEventListener("pointermove", moveDrag);
        document.addEventListener("pointerup", stopDrag);
      }
    };

    const moveDrag = (event) => {
      if (!isDragging) return;

      let clientX = event.touches ? event.touches[0].clientX : event.clientX;
      let clientY = event.touches ? event.touches[0].clientY : event.clientY;

      let dx = clientX - startX;
      let dy = clientY - startY;

      let newX = offsetX + dx;
      let newY = offsetY + dy;

      this.container.style.transform = `translate(${newX}px, ${newY}px)`;
      this.container.dataset.x = newX;
      this.container.dataset.y = newY;
    };

    const stopDrag = () => {
      isDragging = false;

      let parentRect = this.parent.getBoundingClientRect();
      let itemRect = this.container.getBoundingClientRect();
      let finalX = parseFloat(this.container.dataset.x) || 0;
      let finalY = parseFloat(this.container.dataset.y) || 0;

      let allowedOverflowX = itemRect.width * 0.1;
      let allowedOverflowY = itemRect.height * 0.1;

      if (itemRect.left < parentRect.left - allowedOverflowX)
        finalX += parentRect.left - allowedOverflowX - itemRect.left;
      if (itemRect.top < parentRect.top - allowedOverflowY)
        finalY += parentRect.top - allowedOverflowY - itemRect.top;
      if (itemRect.right > parentRect.right + allowedOverflowX)
        finalX -= itemRect.right - (parentRect.right + allowedOverflowX);
      if (itemRect.bottom > parentRect.bottom + allowedOverflowY)
        finalY -= itemRect.bottom - (parentRect.bottom + allowedOverflowY);

      this.container.style.transition = "transform 0.3s ease";
      this.container.style.transform = `translate(${finalX}px, ${finalY}px)`;

      setTimeout(() => {
        this.container.style.transition = "";
        this.container.dataset.x = finalX;
        this.container.dataset.y = finalY;
      }, 300);

      document.removeEventListener("pointermove", moveDrag);
      document.removeEventListener("pointerup", stopDrag);
      document.removeEventListener("touchmove", moveDrag);
      document.removeEventListener("touchend", stopDrag);
    };

    if (this.isTouchDevice) {
      this.container.addEventListener("touchstart", startDrag, {
        passive: false,
      });
    } else {
      this.container.addEventListener("pointerdown", startDrag);
    }
  }
}
// ─── Draggable-instans (behövs för att containern ska gå att dra) ────
new Draggable("#draggableContainer");

// ─── Ny drag-indikator som följer musen och visar “dra”/“välj” ───
const container = document.getElementById("draggableContainer");

// Skapa indikatorn
const dragIndicator = document.createElement("div");
dragIndicator.className = "drag-indicator";
document.body.appendChild(dragIndicator);

// Vid mus in/ut ur containern: visa/dölj indikatorn
container.addEventListener("mouseenter", () => dragIndicator.classList.add("active"));
container.addEventListener("mouseleave", () => dragIndicator.classList.remove("active"));

// Lyssna på mus, pek och touch samtidigt så indikatorn alltid följer
["mousemove","pointermove","touchmove"].forEach(eventType => {
  document.addEventListener(eventType, e => {
    if (!dragIndicator.classList.contains("active")) return;
    // e.pageX/Y för mus & pek; touch-eventet har touches[0]
    const x = e.pageX ??
              (e.touches && e.touches[0] && e.touches[0].pageX) ??
              0;
    const y = e.pageY ??
              (e.touches && e.touches[0] && e.touches[0].pageY) ??
              0;
    dragIndicator.style.left = `${x}px`;
    dragIndicator.style.top  = `${y}px`;
    // Byt text beroende på om pekaren är över en .item
    const overItem = (e.target.closest && e.target.closest("#draggableContainer .item"));
    dragIndicator.textContent = overItem ? window.texts.selectText : window.texts.dragText;
  }, { passive: true });
});


// Artical Picker
let loadContainer = document.querySelector(
  ".listing.articleList .loadContainer"
);
let articlePicker = document.querySelector(".articlePicker");
let product_article_next_button = document.querySelector(
  ".articlePicker .product_article_next_button"
);
let varaint_selection = document.querySelector(".varaint_selection");
let loadMoreBtn = document.querySelector(".loadMoreBtn");
let filterOptions = document.querySelector(".filterOptions");

/* ===========================
   Builder Search (Concept + main-search-builder)
   =========================== */

// Global state (behövs för "LADDA FLER" + dubblettspärr)
window._builderSearch = window._builderSearch || {
  baseQuery: '?q=&type=product&sort_by=relevance', // ändra om du vill ha annan default
  page: 1,
  lastUrl: '',
  seenHandles: new Set()
};

// === Huvudladdning: Hämtar alltid sektionen main-search-builder ===
async function fetchProductGrid(query, LoadingElement) {
  try {
    const prefix = window.localeMarketPrefix || (window.routes && window.routes.root_url) || '';
    const locale = window.shopLocale || (document.documentElement.lang || 'sv').slice(0, 2);

    // Spara state för senare "LADDA FLER"
    window._builderSearch.baseQuery = stripPage(query || window._builderSearch.baseQuery);
    window._builderSearch.page = getPageFromQuery(query) || 1;
    window._builderSearch.seenHandles = new Set();

    // Bygg URL mot sektionen med många per page (styr i section-filen)
    const base = new URL((prefix || '') + '/search' + window._builderSearch.baseQuery, window.location.origin);
    base.searchParams.set('locale', locale);
    base.searchParams.set('section_id', 'main-search-builder');
    // ⚠️ Viktigt: tvinga page=1 så vår pagelogik blir stabil
    base.searchParams.set('page', '1');

    window._builderSearch.page = 1;
    window._builderSearch.lastUrl = base.toString();

    if (LoadingElement) LoadingElement.classList.remove('hidden');
    const res = await fetch(window._builderSearch.lastUrl, { credentials: 'same-origin' });
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');

    // Fyll filtermodalen från sektionen
    renderFiltersFromDocument(doc, window._builderSearch.baseQuery);


    // Rendera första sidan
    const grid = getGrid();
    if (!grid) throw new Error('Hittar inte .collection_articles');
    grid.innerHTML = '';
    await appendProductsFromDoc(doc, grid); // med dubblettspärr

    // Ställ in "LADDA FLER"
    setupLoadMoreFromDoc(doc);

    if (!grid.querySelector('.item')) {
      // Tomt fallback
      const container = document.querySelector('.collection_articles');
      if (container) container.innerHTML = '<div class="noPictureWall">No available Size</div>';
      hideLoadMore();
    }
  } catch (e) {
    console.error('fetchProductGrid error:', e);
  } finally {
    if (LoadingElement) LoadingElement.classList.add('hidden');
  }
}

// === “LADDA FLER” (anropas av onclick="LoadMore(this)" på din knapp) ===
window.LoadMore = async function (btnEl) {
  const btn = btnEl || document.querySelector('.loadMoreBtn, #loadMoreBtn');
  if (!btn) return;

  const loader = btn.querySelector('.loader');
  const grid = document.querySelector('.collection_articles');
  if (!grid) return;

  try {
    btn.disabled = true;
    if (loader) loader.classList.remove('hidden');

    const state = window._builderSearch || (window._builderSearch = { baseQuery:'?q=&type=product&sort_by=relevance', page: 1, lastUrl:'', seenHandles: new Set() });
    let startPage = (state.page || 1) + 1;        // nästa sida efter den vi senast visade
    let addedTotal = 0;

    // Prova upp till 3 sidor i rad (t.ex. om en sida råkar bli tom pga cache/filtrering)
    for (let tries = 0; tries < 3; tries++) {
      const url = buildUrlForPage(startPage);
      const res = await fetch(url, { credentials: 'same-origin' });
      const html = await res.text();
      const doc  = new DOMParser().parseFromString(html, 'text/html');

      const before = grid.querySelectorAll('.item').length;
      await appendProductsFromDoc(doc, grid);       // använder din befintliga dubblettspärr (seenHandles)
      const after  = grid.querySelectorAll('.item').length;
      const added  = after - before;
      addedTotal  += added;

      if (added > 0) {
        // Lyckad sida → uppdatera state och fortsätt bara om användaren klickar igen
        state.page   = startPage;
        state.lastUrl = url;
        break;
      } else {
        // Inga nya kort → hoppa till nästa sida och testa igen
        startPage++;
      }
    }

    // Om vi inte fick in något nytt efter 1–3 försök → göm knappen (slut)
    if (addedTotal === 0) {
      btn.classList.add('hidden');
    } else {
      // Låt knappen vara kvar för nästa klick
      btn.classList.remove('hidden');
      btn.disabled = false;
    }
  } catch (e) {
    console.error('LoadMore failed:', e);
    // Vid fel, visa ändå knappen så man kan försöka igen
    btn.classList.remove('hidden');
  } finally {
    if (loader) loader.classList.add('hidden');
    btn.disabled = false;
  }
};


/* ===========================
   Hjälpare
   =========================== */

// Håller koll om append gav nya item (för att dölja knappen vid slutet)
let hasNewItemsThisAppend = false;

function getGrid() {
  return document.querySelector('.collection_articles') ||
         document.querySelector('.pickerListContainer .items') ||
         document.querySelector('.articlePicker .items');
}

function stripPage(q) {
  try {
    const u = new URL('/search' + (q || ''), window.location.origin);
    u.searchParams.delete('page');
    return '?' + u.searchParams.toString();
  } catch {
    return (q || '').replace(/([?&])page=\d+/i, '$1').replace(/[?&]$/, '');
  }
}

function getPageFromQuery(q) {
  try {
    const u = new URL('/search' + (q || ''), window.location.origin);
    const p = parseInt(u.searchParams.get('page') || '1', 10);
    return isNaN(p) ? 1 : p;
  } catch {
    const m = (q || '').match(/[?&]page=(\d+)/i);
    return m ? parseInt(m[1], 10) : 1;
  }
}

function hideLoadMore() {
  const btn = document.querySelector('.loadMoreBtn, #loadMoreBtn');
  if (btn) btn.classList.add('hidden');
}

function setupLoadMoreFromDoc(doc) {
  const btn = document.querySelector('.loadMoreBtn, #loadMoreBtn');
  if (!btn) return;

  let next = findNextPageUrl(doc);
  if (next) {
    try {
      const u = new URL(next, window.location.origin);
      u.searchParams.set('section_id', 'main-search-builder');
      const locale = window.shopLocale || (document.documentElement.lang || 'sv').slice(0,2);
      u.searchParams.set('locale', locale);
      // dataset kan vara relativt
      next = u.pathname + u.search;
    } catch {
      if (!/section_id=main-search-builder/.test(next)) {
        next += (next.includes('?') ? '&' : '?') + 'section_id=main-search-builder';
      }
    }
    btn.dataset.next = next;
    btn.classList.remove('hidden');
    btn.disabled = false;
  } else {
    // ingen rel="next" → vi använder state-baserad beräkning
    btn.dataset.next = '';
    btn.classList.remove('hidden');
    btn.disabled = false;
  }
}

// Bygg stabil URL mot vår sektion för en given sida
function buildUrlForPage(page) {
  const prefix = window.localeMarketPrefix || (window.routes && window.routes.root_url) || '';
  const locale = window.shopLocale || (document.documentElement.lang || 'sv').slice(0,2);
  const baseQuery = (window._builderSearch && window._builderSearch.baseQuery) || '?q=&type=product&sort_by=relevance';

  const u = new URL((prefix || '') + '/search' + baseQuery, window.location.origin);
  u.searchParams.set('page', String(page));
  u.searchParams.set('section_id', 'main-search-builder');
  u.searchParams.set('locale', locale);
  return u.toString();
}


function findNextPageUrl(doc) {
  const linkNext = doc.querySelector('link[rel="next"]');
  if (linkNext && linkNext.getAttribute('href')) return linkNext.getAttribute('href');

  const aNext =
    doc.querySelector('a[rel="next"]') ||
    doc.querySelector('a.pagination__item.pagination__item--next') ||
    doc.querySelector('.pagination a[href*="page="]:not(.is-current)');
  if (aNext && aNext.getAttribute('href')) return aNext.getAttribute('href');

  return null;
}

function getNextUrlFromState() {
  const prefix = window.localeMarketPrefix || (window.routes && window.routes.root_url) || '';
  const current = window._builderSearch || {};
  // 1) utgå från senast använda URL
  let u;
  try {
    u = new URL(current.lastUrl || ((prefix || '') + '/search' + (current.baseQuery || '?q=')), window.location.origin);
  } catch {
    u = new URL((prefix || '') + '/search' + (current.baseQuery || '?q='), window.location.origin);
  }
  const cur = parseInt(u.searchParams.get('page') || String(current.page || 1), 10);
  const next = isNaN(cur) ? 2 : (cur + 1);

  u.searchParams.set('page', String(next));
  u.searchParams.set('section_id', 'main-search-builder');

  // se till att locale hänger med
  const locale = window.shopLocale || (document.documentElement.lang || 'sv').slice(0,2);
  u.searchParams.set('locale', locale);

  return u.toString();
}


// Försöker först hämta filters via vår JSON-vy (oberoende av tema-HTML).
// Om det blir tomt, faller vi tillbaka till att läsa facet-checkboxar från doc.
async function renderFiltersFromDocument(doc, baseQuery) {
  const container = document.querySelector('.filterOptionsContainer');
  if (!container) return;

  // 1) Försök via vårt egna facets-API (search.builder-facets)
  const ok = await renderFiltersViaFacetJSON(baseQuery, container);
  if (ok) return;

  // 2) Fallback: läs checkboxar i markup (om temat råkar exponera dem)
  let filterRoot =
    doc.querySelector('facet-filters-form') ||
    doc.querySelector('.facets-layout') ||
    doc.querySelector('[data-facets]') ||
    doc.querySelector('form[action="/search"]') ||
    doc.querySelector('form[action^="/search"]');

  if (!filterRoot) {
    container.innerHTML = ''; // inget att visa
    return;
  }

  const allowed = (window.texts && window.texts.allowedFilterHandles) || []; // t.ex. ["artist","konsttemat","color-pattern"]
  const inputs = Array.from(filterRoot.querySelectorAll('input[type="checkbox"][name^="filter."]'));

  const groups = new Map();
  for (const input of inputs) {
    const name = (input.getAttribute('name') || '').trim();  // ex: filter.p.m.custom.konsttemat
    const handle = name.split('.').pop();                     // "konsttemat"
    if (allowed.length && !allowed.includes(handle)) continue;

    let labelText = '';
    const label = input.closest('label') || filterRoot.querySelector(`label[for="${input.id}"]`);
    if (label) labelText = (label.textContent || '').trim();

    const zeroCount = /\(\s*0\s*\)\s*$/.test(labelText);
    const disabled = label && (label.classList.contains('disabled') || zeroCount);

    if (!groups.has(handle)) groups.set(handle, []);
    groups.get(handle).push({ name, value: input.value, disabled, labelText });
  }

  container.innerHTML = '';
  for (const [handle, items] of groups.entries()) {
    renderFilterGroup(container, handle, items);
  }
}

// === Hämtar facets som JSON från vår vy och renderar UI ===
async function renderFiltersViaFacetJSON(baseQuery, container) {
  try {
    const prefix = window.localeMarketPrefix || (window.routes && window.routes.root_url) || '';
    const locale = window.shopLocale || (document.documentElement.lang || 'sv').slice(0,2);

    // Använd nuvarande query men ta bort page=
    const stripped = (function stripPage(q) {
      try { const u = new URL('/search' + (q || ''), location.origin); u.searchParams.delete('page'); return '?' + u.searchParams.toString(); }
      catch { return (q || '').replace(/([?&])page=\d+/i, '$1').replace(/[?&]$/, ''); }
    })(baseQuery || '?q=&type=product');

    // Hämta vår JSON-vy
    const u = new URL((prefix || '') + '/search' + stripped, window.location.origin);
    u.searchParams.set('view', 'builder-facets');
    u.searchParams.set('locale', locale);
    const res = await fetch(u.toString(), { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!res.ok) return false;

    const data = await res.json();
    const filters = Array.isArray(data.filters) ? data.filters : [];
    if (!filters.length) { container.innerHTML = ''; return false; }

    const allowed = (window.texts && window.texts.allowedFilterHandles) || [];
    const groups = new Map();

    for (const f of filters) {
      const name = f.param_name || '';
      if (!name || !name.startsWith('filter.')) continue;
      const handle = name.split('.').pop();
      if (allowed.length && !allowed.includes(handle)) continue;

      const items = (f.values || []).map(v => {
        const count = (typeof v.count === 'number') ? v.count : (v.products || v.result_count || 0);
        return {
          name,
          value: v.value || v.param_value,
          labelText: count != null ? `${(v.label || '').trim()} (${count})` : (v.label || '').trim(),
          disabled: !count || count === 0
        };
      });

      if (!groups.has(handle)) groups.set(handle, []);
      groups.get(handle).push(...items);
    }

    container.innerHTML = '';
    for (const [handle, items] of groups.entries()) {
      renderFilterGroup(container, handle, items);
    }
    return true;
  } catch (e) {
    console.warn('renderFiltersViaFacetJSON failed:', e);
    return false;
  }
}

// === Hjälpare för att rendera en filtergrupp (samma markup som ert gamla UI) ===
function renderFilterGroup(container, handle, items) {
  let html = `<div class="filterOption"><div class="filterOption bold">${capitalize(handle)}</div>`;
  for (const it of items) {
    const selectedArr = (window.selectedFilters && window.selectedFilters[it.name]) || [];
    const isActive = selectedArr.includes(it.value);
    const css = (it.disabled ? 'disable ' : '') + (isActive ? 'active' : '');

    if (handle === 'color-pattern') {
      const clean = (it.labelText || '').split(' (')[0].trim();
      const bg = (typeof getSwatchColor === 'function') ? getSwatchColor(clean) : '#ccc';
      html += `
        <div class="filterItem ${css}" onclick="PickFilter(this)" data-name="${it.name}" data-value="${it.value}">
          <span class="colorItem" style="background:${bg};"></span>
          ${it.labelText}
        </div>`;
    } else {
      html += `
        <div class="filterItem ${css}" onclick="PickFilter(this)" data-name="${it.name}" data-value="${it.value}">
          ${it.labelText}
        </div>`;
    }
  }
  html += `</div>`;
  container.insertAdjacentHTML('beforeend', html);
}

function capitalize(s){ return (s||'').charAt(0).toUpperCase() + (s||'').slice(1); }



// Append:a produkter från sektionens dokument (Concept/Dawn), blockera dubbletter
async function appendProductsFromDoc(doc, grid) {
  hasNewItemsThisAppend = false;

  const nodes = (function pick(d){
    const sels = ['.card.product-card', '.product-grid .grid__item', '[data-product-item]'];
    for (const s of sels) {
      const n = d.querySelectorAll(s);
      if (n && n.length) return Array.from(n);
    }
    return [];
  })(doc);

  if (!nodes.length) return;

  for (const node of nodes) {
    let a = node.querySelector('a[href*="/products/"]') || node.querySelector('a.button') || node.querySelector('a');
    if (!a) continue;

    let href = a.getAttribute('href') || '';
    try { const u = new URL(href, location.origin); href = u.pathname + (u.search || ''); } catch(_){}
    const hm = href.match(/\/products\/([^/?#]+)/);
    if (!hm) continue;
    const handle = hm[1];

    // Dubblettspärr
    if (window._builderSearch.seenHandles.has(handle)) continue;
    window._builderSearch.seenHandles.add(handle);

    let variantId = (href.match(/[?&]variant=(\d+)/)||[])[1];
    if (!variantId) variantId = await getFirstVariant(handle);

    const imgEl = node.querySelector('img');
    const imgSrc = imgEl ? (imgEl.currentSrc || imgEl.src || '') : '';
    const title = (a.textContent && a.textContent.trim()) || (imgEl && imgEl.alt) || handle;

    grid.insertAdjacentHTML('beforeend', `
      <div class="item small-full medium-half large-third smooth"
           data-product-handle="${href.split('?')[0]}"
           data-selected-variant="${variantId || ''}"
           data-product-title="${title.replace(/"/g,'&quot;')}"
           onclick="SelectArticle(this)">
        <div class="inner">
          <div class="image">
            <img src="${imgSrc}" alt="${title.replace(/"/g,'&quot;')}" loading="lazy" width="100" height="120">
          </div>
        </div>
      </div>
    `.trim());

    hasNewItemsThisAppend = true;
  }
}

async function getFirstVariant(handle) {
  try {
    const root = (window.routes && window.routes.root_url) || '';
    const r = await fetch(`${root}/products/${handle}.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!r.ok) return null;
    const p = await r.json();
    const v = (p.variants || []).find(x => x.available) || (p.variants || [])[0];
    return v ? v.id : null;
  } catch { return null; }
}

/* ===========================
   Init: fyll articlePicker vid start
   =========================== */

document.addEventListener('DOMContentLoaded', () => {
  const scroller = document.getElementById('articleScroller');
  if (!scroller) return;
  const loader = document.getElementById('LoadingElement');
  fetchProductGrid(window._builderSearch.baseQuery, loader);
});



// Justerad version av ArticalPicker – säkerställer att articlePicker endast öppnas (inte togglas stängt)
// om den inte redan är aktiv. Samt ser till att clearFilter-elementet hanteras korrekt.
function ArticalPicker(element) {
  loadContainer.classList.remove("hidden");

  // Om ett globalt sparat filterSearch-term finns, överför det till det nya elementet
  if (window.filterSearchTerm) {
    element.dataset.searchTerm = window.filterSearchTerm;
  }
  
  // Ta bort tidigare aktiva item
  const prevActive = document.querySelector(".articlesContainer .item.active");
  if (prevActive) {
    prevActive.classList.remove("active");
  }
  element.classList.add("active");

  // Bygg sökfrågan (basquery) som nu tar hänsyn till dataset.searchTerm
  const searchQuery = buildArticlePickerQuery(element);
  element.setAttribute("data-query", searchQuery);
  // Spara basqueryn på elementet för framtida återställning
  element.setAttribute("data-baseQuery", searchQuery);
  
  // Sätt queryn även för clearFilter-knappen om den finns
  let clearFilterEl = document.querySelector(".clearFilter");
  if (clearFilterEl) {
    clearFilterEl.setAttribute("data-query", searchQuery);
    clearFilterEl.classList.add("disabled");
  }
  
  // Se till att articlePicker är öppen (om den inte redan är aktiv)
  let ap = document.querySelector('.articlePicker');
  if (ap) {
    if (!ap.classList.contains("active") || ap.style.display !== "block") {
      OpenSlide('articlePicker', '');
    }
  }
  
  collection_articles.innerHTML = "";
  fetchProductGrid(searchQuery, loadContainer);
}



function updateArticlePickerSearchTerm(searchTerm) {
  let activeArticle = document.querySelector(".item.active");
  if (!activeArticle) return;

  let size = activeArticle.dataset.size || "";
  let orientation = activeArticle.dataset.orientation || "";
  let typ = activeArticle.dataset.type || "";

  // Använd eller skapa en basquery (den ska vara ofiltrerad)
  let baseQuery = activeArticle.dataset.baseQuery;
  if (!baseQuery) {
    baseQuery = "?q=" + size;
    activeArticle.dataset.baseQuery = baseQuery;
  }

  // Sätt ihop söktermen (hela termen, inte per bokstav)
  let newQ = size;
  if (searchTerm) {
    newQ += " " + searchTerm;
  }

  // Bygg en ny query-sträng med de grundläggande parametrarna
  let newQuery = "?q=" + encodeURIComponent(newQ) + "&options%5Bprefix%5D=last";
  newQuery += "&filter.v.price.gte=&filter.v.price.lte=";
  newQuery += "&filter.p.m.custom.format=" + encodeURIComponent(orientation);
  newQuery += "&filter.p.m.custom.typ_av_produkt=" + encodeURIComponent(typ);
  newQuery += "&sort_by=relevance";

  // Lägg till eventuella aktiva filterparametrar
  let activeFilterParams = getActiveFilterQuery() || "";
  newQuery += activeFilterParams;

  // Uppdatera den aktiva artikelns query och clearFilter-knappen
  activeArticle.dataset.query = newQuery;
  let clearFilterBtn = document.querySelector(".clearFilter");
  if (clearFilterBtn) {
    clearFilterBtn.dataset.query = newQuery;
  }

  collection_articles.innerHTML = "";
  loadContainer.classList.remove("hidden");
  fetchProductGrid(newQuery, loadContainer);
}

function onSearchInputBlur(e) {
  let activeArticle = document.querySelector(".item.active");
  if (!activeArticle) {
    return;
  }
  // Hämta inmatad sökterm och trimma bort eventuella whitespace
  let term = e.target.value.trim();
  // Spara söktermen i det aktiva elementet
  activeArticle.dataset.searchTerm = term;
  // Spara även globalt så att andra item kan använda samma sökterm
  window.filterSearchTerm = term;
  
  document.querySelector(".clearFilter").classList.remove("disabled");
  loadContainer.classList.remove("hidden");
  
  // Uppdatera queryn baserat på basquery + sökterm + eventuella filter
  updateActiveArticleQuery();
  collection_articles.innerHTML = "";
  fetchProductGrid(activeArticle.dataset.query, loadContainer);
}

// Använd samma funktion för båda om de är avsedd att bete sig lika:
let filterSearchInput = document.querySelector(".filterSearchInput");
if (filterSearchInput) {
  filterSearchInput.addEventListener("blur", onSearchInputBlur);
}

let mobileInput = document.querySelector(".mobileInput");
if (mobileInput) {
  mobileInput.addEventListener("blur", onSearchInputBlur);
}


function PickFilter(element) {
  let key = element.dataset.name;
  let value = element.dataset.value;

  if (!window.selectedFilters[key]) window.selectedFilters[key] = [];

  const idx = window.selectedFilters[key].indexOf(value);
  if (idx > -1) {
    window.selectedFilters[key].splice(idx, 1);
    element.classList.remove('active');       // <— direkt feedback
  } else {
    window.selectedFilters[key].push(value);
    element.classList.add('active');          // <— direkt feedback
  }

  // …resten av din befintliga kod…
  let activeArticle = document.querySelector(".item.active");
  if (!activeArticle) return;
  if (!activeArticle.dataset.baseQuery) {
    activeArticle.dataset.baseQuery = buildBaseQuery(activeArticle);
  }
  updateActiveArticleQuery();

  collection_articles.innerHTML = "";
  loadContainer.classList.remove("hidden");
  fetchProductGrid(activeArticle.dataset.query, loadContainer);

  // Synka även övriga kopior av filterlistan (t.ex. i modal)
  updateFilterOptionsActiveState();
  updateFilterModalContent();
}


function updateFilterOptionsActiveState() {
  const filterItems = document.querySelectorAll(".filterOptions .filterItem");
  filterItems.forEach(item => {
    const key = item.dataset.name;
    const value = item.dataset.value;
    if (window.selectedFilters[key] && window.selectedFilters[key].includes(value)) {
      item.classList.add("active");
    } else {
      item.classList.remove("active");
    }
  });
}


function clearFilterFunction() {
  // Nollställ de globala filtervariablerna
  window.selectedFilters = {};
  window.filterSearchTerm = "";
  
  // Rensa innehållet i filterSearchInput (om den finns)
  var filterSearchInput = document.querySelector(".filterSearchInput");
  if (filterSearchInput) {
    filterSearchInput.value = "";
  }
  
  // Rensa söktermen (dataset.searchTerm) för alla items i draggable-container
  document.querySelectorAll(".articlesContainer .item").forEach(function(item) {
    item.dataset.searchTerm = "";
  });
  
  // Hämta den aktuella aktiva artikeln och uppdatera dess query med en ny beräkning
  let activeArticle = document.querySelector(".item.active");
  if (activeArticle) {
    // Bygg om queryn med den aktuella, nu tomma, söktermen
    let newQuery = buildArticlePickerQuery(activeArticle);
    activeArticle.dataset.query = newQuery;
    
    // Uppdatera clearFilter-knappens data och sätt knappen i disabled-läge
    let clearFilterBtn = document.querySelector(".clearFilter");
    if (clearFilterBtn) {
      clearFilterBtn.dataset.query = newQuery;
      clearFilterBtn.classList.add("disabled");
    }
  }
  
  // Ta bort visuella markeringar från filteralternativen
  updateFilterOptionsActiveState();
  
  // Uppdatera produktlistan direkt med den nya query-strängen
  if (activeArticle) {
    collection_articles.innerHTML = "";
    loadContainer.classList.remove("hidden");
    fetchProductGrid(activeArticle.dataset.query, loadContainer);
  }
  
  // Uppdatera filtermodalens innehåll (så att rätt filter visas)
  updateFilterModalContent();
}

function resetActiveFiltersInUI() {
  // Se till att alla filterknappar (och andra filterrelaterade element) återställs
  let filterItems = document.querySelectorAll(".filterOptions .filterItem");
  filterItems.forEach(item => {
    item.classList.remove("active");
    item.classList.remove("selected-filter");
  });
}




// Om du har en eventlyssnare, ersätt den med:
document.querySelector(".clearFilter").addEventListener("click", clearFilterFunction);


function LoadMore(element) {
  let loaderElement = element.querySelector(".loader");
  loaderElement.classList.remove("hidden");
  let nextpage = parseInt(element.dataset.pageIndex) + 1;
  let queryshouldbe = element.dataset.query + "&page=" + nextpage;
  fetchProductGrid(queryshouldbe, loaderElement); // Replace with actual URL
}

function mergeDuplicateItems(items) {
  return Object.values(
    items.reduce((acc, item) => {
      if (acc[item.id]) {
        acc[item.id].quantity += item.quantity;
      } else {
        acc[item.id] = { ...item };
      }
      return acc;
    }, {})
  );
}

function Basket(itemIndex, image_src, product_title, price) {
  // Använd data-item-index istället för data-position
  let basket = chosenArticlesBasket.querySelector(`.article[data-item-index="${itemIndex}"]`);
  if (!basket) {
    // Skapa basket-uppgiften om den inte finns
    basket = document.createElement("div");
    basket.className = "article";
    basket.dataset.itemIndex = itemIndex;
    chosenArticlesBasket.appendChild(basket);
  }
  basket.innerHTML = `
    <div class="left">
      <div class="image">
        <div class="inner">
          <img src="${image_src}" width="auto" height="auto" loading="lazy">
        </div>
      </div>
    </div>
    <div class="right">
      <div class="tiny-heading">${product_title}</div>
      <div class="price">
        ${Shopify.formatMoney(price)}
      </div>
    </div>
  `;
  basket.classList.remove("hidden");
}

function SumPrices() {
  // Hämta alla .chosenArticle som ligger inom .item med klassen hasArticle i draggable-containern
  const chosenArticles = document.querySelectorAll("#draggableContainer .item.hasArticle .chosenArticle");
  let totalPriceCents = 0;
  
  chosenArticles.forEach(article => {
    // Här förutsätter vi att data-price innehåller priset i en "enhet" (t.ex. kronor) och vi multiplicerar med 100
    // Om dina priser redan är i rätt enhet (t.ex. cent) tar du bort multiplikationen.
    totalPriceCents += parseFloat(article.dataset.price) * 100;
  });

  // Uppdatera prissumman i kontrollbarens element med id "priceAmount"
  document.getElementById("priceAmount").innerHTML = Shopify.formatMoney(totalPriceCents);

  // Om du har ytterligare element som ska uppdateras (t.ex. en desktop- och en mobilversion), uppdatera dem här.
  // Exempel:
  let priceContainerPrice = document.querySelector("#priceContainerPrice");
  if (priceContainerPrice) {
    priceContainerPrice.innerHTML = Shopify.formatMoney(totalPriceCents);
  }

  let priceContainerPriceMobile = document.querySelector(".priceContainerPriceMobile");
  if (priceContainerPriceMobile) {
    priceContainerPriceMobile.innerHTML = Shopify.formatMoney(totalPriceCents);
  }
}

async function SelectArticle(article) {
  // Dölj next-knappen tills processen är klar
  product_article_next_button.classList.add("hidden");

  // Hämta det aktiva draggable-itemet
  let activeArticle = document.querySelector(".item.active");
  if (!activeArticle) {
    return;
  }

  // Nollställ variant-vy och visa loader
  varaint_selection.innerHTML = "";
  loadContainer.classList.remove("hidden");

  try {
    // --- 1) Bygg rätt URL för JSON ---
     const prefix = window.localeMarketPrefix;
     const locale = window.shopLocale       || "";
     const lang   = window.shopLocale       || "sv";
    let handlePath = article.dataset.productHandle.replace(/^https?:\/\/[^/]+/, '');
    // Släng ev. gammalt språk/market-prefix så vi kan sätta rätt
    handlePath = handlePath.replace(/^\/[a-z]{2}(?:-[a-z0-9]+)?\//, '/');              // "/en-eu"
    const productPath = `${prefix}${handlePath}`;
    const fetchUrl    = `${productPath}.json?locale=${window.shopLocale}&currency=${currency}`;

    const response = await fetch(fetchUrl, {
      credentials: "same-origin",
      headers: {
        'Accept-Language': window.shopLocale
      }
    });
     const data     = await response.json();
    
    // --- 3) Välj default-variant på size (option1) ---
    let selectedSize   = activeArticle.dataset.size || article.dataset.size;
    let defaultVariant = data.product.variants.find(v => 
      normalizeOption(v.option1) === normalizeOption(selectedSize)
    ) || data.product.variants.find(v => v.id == article.dataset.selectedVariant);
    if (!defaultVariant) {
      return;
    }
    if (!defaultVariant) {
      return;
    }

    // --- 4) Bild, titel, pris ---
    let imageSrc       = (data.product.images.find(img=>img.id===defaultVariant.image_id)||{}).src;
    let product_title  = data.product.title;
    let defaultCents   = Math.round(parseFloat(defaultVariant.price) * 100);
    let price_container= Shopify.formatMoney(defaultCents);

    // --- 5) Dynamisk marginalhantering (om du har option2="Marginal") ---
    const marginLabel   = window.texts.marginLabel || "Marginal";
    const hasMarginField= data.product.options.some(opt => opt.name === marginLabel);
    const marginOptions = hasMarginField
      ? Array.from(new Set(data.product.variants.map(v=>v.option2).filter(o=>o)))
      : [];
    window.currentHasMargin = marginOptions.length > 1;
    if (hasMarginField && marginOptions.length > 1) {
      window.currentHasMargin = true;
      // Rendera marginal-slider
      varaint_selection.innerHTML = `
        <img src="${imageSrc}&width=280" loading="lazy" class="margin_varaint_image"/>
        <h2 class="title inline-richtext">${product_title}</h2>
        <div class="price__container">${price_container}</div>
        <div class="variant-selector">
          <div class="marginal-options">
            <label>${marginLabel}</label>
            <div class="option-values">
              ${marginOptions.map(opt => {
                // Hitta första variant för margin (som fallback)
                const variant = data.product.variants.find(
                  v => v.option1 === selectedSize && v.option2 === opt
                );
              
                // Bygg alla ramvarianter för just denna marginal
                const frameVariants = data.product.variants
                  .filter(v => 
                    normalizeOption(v.option1) === normalizeOption(selectedSize) &&
                    normalizeOption(v.option2) === normalizeOption(opt)
                  )
                  .map(v => ({
                    id: v.id,
                    option: v.option3,
                    image: (data.product.images.find(i => i.id === v.image_id) || { src: imageSrc }).src,
                    price: v.price,
                  }));
              
                // Här är den översättningsbara delen!
                const noFrameLabel = window.texts?.noFrame || "Ingen ram";
                // Hitta rätt frame, annars ta första
                const firstFrame = frameVariants.find(fv => fv.option === noFrameLabel) || frameVariants[0];
                const marginImg = firstFrame?.image || imageSrc;
              
                return `
                  <div class="option-value"
                       data-variant-id="${firstFrame.id}"
                       data-price="${firstFrame.price}"
                       data-marginal="${opt}"
                       data-frame-variants='${JSON.stringify(frameVariants)}'
                       onclick="changeVariant(this)">
                    <img src="${marginImg}&width=280" loading="lazy"/>
                    <div class="name tiny-heading">${opt}</div>
                  </div>
                `;
              }).join("")}
            </div>
          </div>
        </div>
      `;
      varaint_selection.classList.add("active");
      document.querySelector(".product_variant_options_button_back").classList.remove("hidden");

      // Initiera chosenArticle med första margin-variant (bara för att ha ett valt)
      const firstVar = data.product.variants.find(v =>
        normalizeOption(v.option1) === normalizeOption(selectedSize) &&
        normalizeOption(v.option2) === normalizeOption(marginOptions[0])
      );
      
      if (!firstVar) {
        return; // avbryt om inget matchar
      }
      
      // Bygg frame‐varianter för just den margin‐varianten
      const frameVariantsForFirst = data.product.variants
        .filter(v =>
          normalizeOption(v.option1) === normalizeOption(selectedSize) &&
          normalizeOption(v.option2) === normalizeOption(marginOptions[0])
        )
        .map(v => ({
          id:     v.id,
          option: v.option3 || window.texts.noFrame || "Ingen ram",
          image:  (data.product.images.find(i => i.id === v.image_id) || { src: imageSrc }).src,
          price:  v.price
        }));
      
      const firstFrameImg = frameVariantsForFirst[0]?.image || imageSrc;
      
      window.currentItemIndex = activeArticle.dataset.itemIndex;
      activeArticle.innerHTML = `
        <div class="chosenArticle"
             data-variant-id="${frameVariantsForFirst[0].id}"
             data-price="${frameVariantsForFirst[0].price}"
             data-base-product-price="${defaultVariant.price}"
             data-position="${activeArticle.dataset.position}"
             data-product-title="${product_title}"
             data-image-src="${firstFrameImg}"
             data-selectedMargin="${marginOptions[0]}"
             data-frame-variants='${JSON.stringify(frameVariantsForFirst)}'
             data-item-index="${activeArticle.dataset.itemIndex}"
             style="background-image: url('${firstFrameImg}');">
        </div>
      `;
      
      loadContainer.classList.add("hidden");
      activeArticle.classList.add("hasArticle");
      SumPrices();
      return; // hoppa över ram-fallbacken
    }

window.currentHasMargin = false;
document.querySelector(".product_variant_options_button_back").classList.add("hidden");
window.currentItemIndex = activeArticle.dataset.itemIndex;

// Rendera chosenArticle direkt utan att visa marginal-UI
activeArticle.innerHTML = `
  <div class="chosenArticle"
       data-variant-id="${defaultVariant.id}"
       data-price="${defaultVariant.price}"
       data-base-product-price="${defaultVariant.price}"
       data-position="${activeArticle.dataset.position}"
       data-product-title="${product_title}"
       data-image-src="${imageSrc}"
       data-item-index="${activeArticle.dataset.itemIndex}"
       style="background-image: url('${imageSrc}');">
  </div>
`;
activeArticle.classList.add("hasArticle");
product_article_next_button.classList.remove("hidden");

// Hämta alla ram-varianter (option2)
const frameVariants = data.product.variants
  .filter(v => normalizeOption(v.option1) === normalizeOption(selectedSize))
  .map(v => ({
    id:     v.id,
    option: v.option2 || window.texts.noFrame || "Ingen ram",
    image:  (data.product.images.find(i => i.id === v.image_id) || { src: imageSrc }).src,
    price:  v.price
  }));

// Spara in så FrameOptions kan plocka upp dem
const chosenArt = activeArticle.querySelector(".chosenArticle");
chosenArt.dataset.frameVariants = JSON.stringify(frameVariants);
chosenArt.dataset.selectedFrame  = frameVariants[0].option;

// Kör FrameOptions med liten timeout så allt finns på plats
setTimeout(() => {
  SumPrices();
  FrameOptions(
    activeArticle.dataset.itemIndex,
    product_title,
    imageSrc,
    frameVariants
  );
}, 0);

    // Uppdatera kundvagns-vy etc.
    Basket(activeArticle.dataset.position, imageSrc, product_title, defaultVariant.price);

    // Markera att vi fyllt ett item
    activeArticle.classList.add("hasArticle");
    product_article_next_button.classList.remove("hidden");
    if (document.querySelectorAll(".articlesContainer .item:not(.hasArticle)").length === 0) {
      pickMotifs.classList.add("done");
    }
    beforeChosenOkText.classList.remove("hidden");
    loadContainer.classList.add("hidden");
  }
  catch(err){
  }
}

function changeVariant(element) {
  // 1) Plocka ut de data vi behöver
  const variantId    = element.dataset.variantId;
  const price        = element.dataset.price;
  const selectedMargin = element.dataset.marginal;
  const frameVariants = element.dataset.frameVariants;
  const imgSrc       = element.querySelector("img").src;

  // 2) Hitta det draggable-item vi jobbar mot
  const activeItem = document.querySelector(`.articlesContainer .item.active`);
  if (!activeItem) {

    return;
  }
  const chosenArt = activeItem.querySelector(".chosenArticle");
  if (!chosenArt) {

    return;
  }

  // 3) Sätt de nya värdena på chosenArticle
  chosenArt.dataset.variantId  = variantId;
  chosenArt.dataset.price      = price;
  chosenArt.dataset.selectedMargin = selectedMargin;
  if (frameVariants) {
    chosenArt.dataset.frameVariants = frameVariants;
  }
  chosenArt.style.backgroundImage = `url('${imgSrc}')`;

  // 4) Uppdatera ram‐väljaren direkt
  let productTitle = activeItem.dataset.productTitle || "";
  if (chosenArt.dataset.frameVariants) {
    const frames = JSON.parse(chosenArt.dataset.frameVariants);
    FrameOptions(activeItem.dataset.itemIndex, productTitle, imgSrc, frames);
  }

  // 5) Prissummering
  SumPrices();

  // 6) Markera rutan som fylld så vi inte återaktiverar den senare
  if (!activeItem.classList.contains("hasArticle")) {
    activeItem.classList.add("hasArticle");
  }

  // 7) Dölj marginal‐sliden och återställ flagga
  CloseSlide('varaint_selection');
  window.justHadMargin = false;

  // 8) Visa ”Nästa”-knappen
  product_article_next_button.classList.remove("hidden");
}

function FrameOptions(itemIndex, product_title, imageSrc, data) {
  if (!product_title) {
    // Prova läsa titeln från .chosenArticle:
    let fallback = document.querySelector(`.articlesContainer .item[data-item-index="${itemIndex}"] .chosenArticle`);
    if (fallback) {
      product_title = fallback.dataset.productTitle || "[ingen titel i data-product-title!]";

    } else {

    }
  }
  // Översättbara etiketter från dina settings
  const frameLabel    = window.texts.frameLabel   || "Ram";
  const noFrameLabel  = window.texts.noFrame      || "Ingen ram"; // lägg till noFrame i dina settings om du vill

  // Hitta eller skapa container för just det här itemIndex
  let container = document.querySelector(`.basket_for_frame .frame[data-item-index="${itemIndex}"]`);
  if (!container) {
    container = document.createElement("div");
    container.className = "frame";
    container.dataset.itemIndex = itemIndex;
    document.querySelector(".basket_for_frame").appendChild(container);
  }

  // Om inga varianter → visa bara “Ingen ram”
  if (!Array.isArray(data) || data.length === 0) {
    container.innerHTML = `
      <div class="inner">
        <img src="${imageSrc}&width=280" loading="lazy" />
        <h2 class="title inline-richtext">${product_title}</h2>
        <label>${frameLabel}: <span class="frame-label">${noFrameLabel}</span></label>
      </div>
    `;
    container.classList.remove("hidden");
    return;
  }

  // Välj default (första) om det inte finns någon med exakt “Ingen ram”
  const defaultVariant = data.find(v => v.option === noFrameLabel) || data[0];
  const defaultOption  = defaultVariant.option || noFrameLabel;

  // Bygg ut HTML
  container.innerHTML = `
    <div class="inner">
      <img 
        src="${imageSrc}&width=280" 
        loading="lazy" 
        class="frame_varaint_image" />
      <h2 class="title inline-richtext">${product_title}</h2>
      <label>${frameLabel}: <span class="frame-label">${defaultOption}</span></label>
      <div class="frame_object_sdklfjwsoeiffdsvjn">
        ${data.map(variant => {
          const name = variant.option || noFrameLabel;
          return `
            <div 
              class="frameItem item ${name === defaultOption ? "selected" : ""}" 
              onclick="selectFrame(this)" 
              data-variant-id="${variant.id}"
              data-variant-image="${variant.image}"
              data-variant-price="${variant.price}"
              data-item-index="${itemIndex}"
              data-frame-name="${name}"
            >
              <img 
                src="${variant.image}&width=280" 
                width="280" height="auto" loading="lazy" />
              <div class="name tiny-heading">${name}</div>
              <div class="price">
                ${(() => {
                  const cents = Math.round(parseFloat(variant.price) * 100);
                  return Shopify.formatMoney(cents);
                })()}
              </div>
            </div>
          `;
        }).join("")}
      </div>
    </div>
  `;
  container.classList.remove("hidden");
}

function selectFrame(element) {
  const frameName = element.dataset.frameName;
  const variantId = element.dataset.variantId;
  const variantPrice = element.dataset.variantPrice; // Detta skall vara det totala (helhets-)priset
  const imgEl = element.querySelector("img");
  const selectedFrameImgSrc = imgEl ? imgEl.src : "";
  
  const frameContainer = element.closest(".frame");
  let itemIndex = frameContainer ? frameContainer.dataset.itemIndex : null;
  if (itemIndex === null) {

    return;
  }
  const targetDraggableItem = document.querySelector(`.articlesContainer .item[data-item-index="${itemIndex}"]`);
  if (!targetDraggableItem) {

    return;
  }
  let chosenArticle = targetDraggableItem.querySelector(".chosenArticle");
  if (!chosenArticle) {

    return;
  }

    // Ta bort "selected" från alla ramalternativ i samma container
  let allFrameItems = frameContainer.querySelectorAll(".frameItem");
  allFrameItems.forEach(item => item.classList.remove("selected"));
  // Lägg till "selected" på det klickade elementet
  element.classList.add("selected");
  
  // Uppdatera chosenArticle med de nya värdena
  chosenArticle.dataset.variantId = variantId;
  chosenArticle.dataset.price = variantPrice; // Uppdatera med nytt rampris
  chosenArticle.dataset.selectedFrame = frameName;
  chosenArticle.style.backgroundImage = `url('${selectedFrameImgSrc}')`;
  
  // Uppdatera framePicker-labeln (om den finns)
  const frameLabel = frameContainer.querySelector(".frame-label");
  if (frameLabel) {
    frameLabel.textContent = frameName;
  }
  
  // Uppdatera korgen med rätt pris
  Basket(itemIndex, selectedFrameImgSrc, chosenArticle.dataset.productTitle || "", variantPrice);
  
  // Summera priserna
  SumPrices();
}

function renderAllFrameOptions() {
  const chosenArticles = document.querySelectorAll('#draggableContainer .item.hasArticle .chosenArticle');
  chosenArticles.forEach(article => {
    let pos = article.dataset.position;
    let productTitle = article.dataset.productTitle;
    let imageSrc = article.dataset.imageSrc;
    let frameVariants = article.dataset.frameVariants 
                        ? JSON.parse(article.dataset.frameVariants) 
                        : [{ id: article.dataset.variantId, option: "Ingen ram", price: article.dataset.price, image: imageSrc }];
    FrameOptions(pos, productTitle, imageSrc, frameVariants);
  });
}

function b64toBlob(b64Data, contentType, sliceSize) {
  contentType = contentType || "";
  sliceSize = sliceSize || 512;
  let byteCharacters = atob(b64Data);
  let byteArrays = [];
  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    let slice = byteCharacters.slice(offset, offset + sliceSize);

    let byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    let byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  let blob = new Blob(byteArrays, { type: contentType });
  return blob;
}

async function postWallImg(base64 = "") {
  let image = base64;
  let block = image.split(";");
  let contentType = block[0].split(":")[1];
  let realData = block[1].split(",")[1];
  let blob = b64toBlob(realData, contentType);
  let formDataToUpload = new FormData();
  const formData = new FormData();
  formData.append("file", blob);
  formData.append("upload_preset", "pv0c9yjj11");
  try {
    const response = await fetch(
      "https://api.cloudinary.com/v1_1/devihvdp5/upload",
      {
        method: "POST",
        body: formData,
      }
    );

    const data = await response.json();
    return data;
  } catch (error) {

  }
}
/*async function AddToCart() {
  let pictureWall = document.querySelector("#pictureWall");
  let loading = document.querySelector(".modalContainer");
  loading.classList.remove("hidden");
  let dataObject = [];
  let variantIds = document.querySelectorAll(
    ".articlesContainer .item.hasArticle .chosenArticle"
  );

  try {
    let galleryWallImage = await domtoimage.toPng(pictureWall);
    let wallImageUrl = await postWallImg(galleryWallImage);
    variantIds.forEach((variant) => {
      dataObject.push({
        id: parseInt(variant.dataset.variantId),
        quantity: 1,
        properties: {
          "Gallery Wall Image": wallImageUrl.url,
        },
      });
    });
    dataObject = mergeDuplicateItems(dataObject);
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: dataObject,
      }),
    });
    const data = await response.json();
    const successCart = data;
    console.log("Cart updated:", successCart);
    window.location.href = "/cart";
  } catch (error) {
    console.error("Error uploading file:", error);
  }
}*/

async function AddToCart() {
  // Skapa en tom array för de objekt vi ska lägga i kundvagnen
  let items = [];
  
  // Hämta alla .chosenArticle-element från din draggable container
  const chosenArticles = document.querySelectorAll("#draggableContainer .item.hasArticle .chosenArticle");

  // Loopa igenom och plocka ut variant-id och önskad kvantitet (här sätter vi alltid 1)
  chosenArticles.forEach(article => {
    items.push({
      id: parseInt(article.dataset.variantId), // variant-id sparat i data-variant-id
      quantity: 1
    });
  });

  try {
    // Skicka en POST-request till Shopify’s AJAX-cart endpoint
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    });
    const data = await response.json();

    
    // Vid ett lyckat anrop, vidarebefordra användaren till utcheckningssidan
    window.location.href = '/checkout';
  } catch (error) {

  }
}


// Force mobile browser UI to hide
function hideBrowserUI() {
  window.scrollTo(0, 1);
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
}

// Adjust layout on changes
function adjustLayout() {
  document.documentElement.style.setProperty(
    "--dvh",
    `${window.innerHeight}px`
  );
  hideBrowserUI();
}

function showBackgroundSelection() {
  // Dölj välkomstvyn
  document.getElementById('welcome').style.display = 'none';
  // Visa bakgrundsvyn
  document.getElementById('backgroundSelection').style.display = 'block';
}

function OpenSlideById(showId, hideId) {
  if (hideId && document.getElementById(hideId)) {
    document.getElementById(hideId).style.display = 'none';
  }
  const el = document.getElementById(showId);
  if (!el) return;
  el.style.display = 'flex';                    // <— viktigt för centrering (flex)
  el.classList.add('active', 'slide-in-from-right');
  setTimeout(() => el.classList.remove('slide-in-from-right'), 300);
}


function toggleSlideById(elementId, hideId) {
  var el = document.getElementById(elementId);
  if (!el) return;
  if (el.classList.contains("active") && el.style.display === "block") {
    document.getElementById(elementId).style.display = 'none';
    el.classList.remove("active");
  } else {
    OpenSlideById(elementId, hideId);
  }
}


function selectPresetBackground(element) {
  // Hämta vald preset från data-attributet
  var selectedBg = element.getAttribute('data-bg');
  window.selectedBackground = selectedBg;

  // Ta bort "selected"-klassen från alla presets och lägg på den klickade
  var items = document.querySelectorAll('.presetGridItem');
  items.forEach(function(item) {
    item.classList.remove('selected');
  });
  element.classList.add('selected');

  // Uppdatera bakgrundspreviewen direkt i #zoomElement
  document.getElementById('zoomElement').style.backgroundImage = 'url(' + window.selectedBackground + ')';


      if (window.selectedBackground) {
    document.getElementById('zoomElement').style.backgroundImage = 'url(' + window.selectedBackground + ')';
    document.getElementById('backgroundSelection').style.backgroundImage = 'url(' + window.selectedBackground + ')';
  }
}

function confirmPresetSelection() {
  // Kontrollera att en bakgrund är vald
  if (!window.selectedBackground) {
    alert('Vänligen välj en bakgrund från presets.');
    return;
  }
  
  // Uppdatera bakgrundspreviewen direkt i #zoomElement
  document.getElementById('zoomElement').style.backgroundImage = 'url(' + window.selectedBackground + ')';
  
  // Stäng preset-modalen
  closePresetModal();
  
  // Om bakgrundsbytet INTE sker från kontrollbaren (dvs. första gången) öppnas tavelmallsmodalen
if (!isBackgroundChangedFromControl) {
  hideLegacyFramePicker();                 // <-- se till att gamla aldrig visas
  OpenSlideById('templateModal', 'backgroundSelection'); // <-- öppna bara nya modal
} else {
  isBackgroundChangedFromControl = false;
  document.getElementById('backgroundSelection').style.display = 'none';
}
  
  // Om både bakgrund och mall redan är valda, visa kontrollbaren
  if (window.selectedBackground && window.selectedTemplate) {
    showControlBar();
  }
}



function closePresetModal() {
  document.getElementById('presetModal').style.display = 'none';
}

// Visa upp modalen när användaren trycker på "Välj färdiga väggar"
function showPreset() {
  document.getElementById('presetModal').style.display = 'flex';
}

function updateFilterModalContent() {
  // Rendera filtren in-place i .filterOptionsContainer för aktuell query.
  renderFiltersFromDocument(null, window._builderSearch.baseQuery);
}

function getActiveFilterQuery() {
  let query = "";
  for (let key in window.selectedFilters) {
    if (window.selectedFilters[key] && window.selectedFilters[key].length > 0) {
      window.selectedFilters[key].forEach(val => {
        query += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(val);
      });
    }
  }
  return query;
}


function buildArticlePickerQuery(element) {
  // Bygg upp basqueryn med produktens storlek
  let baseQuery = `?q=${element.dataset.size}`;
  // Om elementet har en sparad sökterm (t.ex. från filterSearchInput), lägg till den
  if (element.dataset.searchTerm) {
    baseQuery += `+${encodeURIComponent(element.dataset.searchTerm)}`;
  }
  // Lägg till övriga parametrar
  baseQuery += `&options%5Bprefix%5D=last` +
    `&filter.v.price.gte=&filter.v.price.lte=` +
    `&filter.p.m.custom.format=${encodeURIComponent(element.dataset.orientation)}` +
    `&filter.p.m.custom.typ_av_produkt=${encodeURIComponent(element.dataset.type)}` +
    `&sort_by=relevance`;
  // Spara basqueryn på elementet för senare återställning
  element.dataset.baseQuery = baseQuery;
  // Hämta filterparametrarna från den globala variabeln
  let activeFilterParams = getActiveFilterQuery() || "";
  return baseQuery + activeFilterParams;
}


function toggleFilterModal() {
  const modal = document.getElementById('filterModal');
  const filterButtonSpan = document.querySelector(".filterPanel .filterButton span.show");
  
  if (modal && window.getComputedStyle(modal).display === "block") {
    closeFilterModal();
    if (filterButtonSpan) {
      filterButtonSpan.innerHTML = window.texts.showFilter + "<i class='fa fa-search'></i>";
    }
  } else {
    openFilterModal();
    if (filterButtonSpan) {
      filterButtonSpan.innerHTML = window.texts.closeFilter + "<i class='icon-close bold'></i>";
    }
  }
}

function openFilterModal() {
  document.body.classList.add('filter-open');
  updateFilterModalContent();            // din befintliga
  OpenSlideById("filterModal", "");      // din befintliga

  // Nollställ scrollen efter att modalen blivit synlig
  requestAnimationFrame(() => {
    const root    = document.getElementById('filterModal');
    const content = root && root.querySelector('.filterModalContent');
    const body    = root && root.querySelector('.modalBody');

    [body, content, root].forEach(el => {
      if (!el) return;
      // undvik smooth-scroll vid reset
      const prev = el.style.scrollBehavior;
      el.style.scrollBehavior = 'auto';
      el.scrollTop = 0;
      el.style.scrollBehavior = prev || '';
    });
  });

  const filterButton = document.querySelector(".filterPanel .filterButton span.show");
  if (filterButton) {
    filterButton.innerHTML = window.texts.closeFilter + "<i class='icon-close bold'></i>";
  }
}


function closeFilterModal() {
  document.body.classList.remove('filter-open');
  document.getElementById('filterModal').style.display = 'none';
  const filterButton = document.querySelector(".filterPanel .filterButton span.show");
  if (filterButton) {
    filterButton.innerHTML = window.texts.showFilter + "<i class='fa fa-search'></i>";
  }
}

function ensureFilterModalTopVisible() {
  const modal = document.getElementById('filterModal');
  if (!modal) return;

  // Kandidater som KAN ha scroll (beroende på befintlig CSS)
  const scrollers = [
    modal.querySelector('.modalBody'),
    modal.querySelector('.filterModalContent'),
    modal
  ].filter(Boolean);

  // Tillfälligt slå av smooth scroll så hoppet blir exakt
  scrollers.forEach(el => { el.style.scrollBehavior = 'auto'; el.scrollTop = 0; });

  // Säkerställ två gånger när layout är färdig
  requestAnimationFrame(() => scrollers.forEach(el => el.scrollTop = 0));
  setTimeout(() => scrollers.forEach(el => el.scrollTop = 0), 50);
}

// Filuppladdning och val av uppladdad bakgrund
function showUpload() {
  document.getElementById('uploadContent').style.display = 'block';
  document.getElementById('presetContent').style.display = 'none';
  // Trigga filväljaren
  document.getElementById('backgroundUpload').click();
}

function uploadBackground() {
  var fileInput = document.getElementById('backgroundUpload');
  if (fileInput.files && fileInput.files[0]) {
    var reader = new FileReader();
    reader.onload = function (e) {
      window.selectedBackground = e.target.result; // DataURL
      // Uppdatera förhandsvisningen
      document.getElementById('zoomElement').style.backgroundImage = 'url(' + window.selectedBackground + ')';
      // Gå vidare direkt (samma som bekräftelse)
      confirmBackgroundSelection();
    };
    reader.readAsDataURL(fileInput.files[0]);
  }
}

// Vi justerar confirmBackgroundSelection så att den hanterar båda fallen.
function confirmBackgroundSelection() {
  if (!window.selectedBackground) {
    alert('Vänligen välj eller ladda upp en bakgrund.');
    return;
  }
  // Uppdatera bakgrundsbilden på #zoomElement (preview)
  document.getElementById('zoomElement').style.backgroundImage = 'url(' + window.selectedBackground + ')';
  // Dölj bakgrundsvyn
  document.getElementById('backgroundSelection').style.display = 'none';
  
  // Om bakgrundsvalet sker första gången (ej via kontrollbaren) – gå vidare till tavelmallsmodalen
if (!isBackgroundChangedFromControl) {
  hideLegacyFramePicker();
  OpenSlideById('templateModal', 'backgroundSelection');
}

  // Återställ flaggan
  isBackgroundChangedFromControl = false;
  
  // Visa kontrollbaren om både bakgrund och mall är valda
  if (window.selectedBackground && window.selectedTemplate) {
    showControlBar();
  }
}

// Funktion: Hantera klick på en tavelmall (template)
function selectTemplate(element) {
  var newTemplate = element.getAttribute('data-template');
  var frameIndex = element.getAttribute('data-index');

  // Om en mall redan är vald
  if (window.selectedTemplate) {
    // Om den nya mallen är densamma som den redan valda – stäng tavelmallsvyn och avsluta
    if (window.selectedTemplate === newTemplate) {
      closeTemplateModal();
      return;
    } else {
      // Om en annan mall väljs, visa vår reset-warning modal
      showResetWarningModal(function () {
        // Callback – applicera den nya mallen
        applyTemplateChange(frameIndex, newTemplate, element);
      });
      return; // Vänta på användarens val i modal-fönstret
    }
  }

  // Om ingen mall var vald tidigare, applicera den direkt
  applyTemplateChange(frameIndex, newTemplate, element);
}

function applyTemplateChange(frameIndex, newTemplate, element) {
  // Spara den nya tavelmallen
  window.selectedTemplate = newTemplate;
  
  // Markera den valda mallen visuellt
  var items = document.querySelectorAll('#templateModal .presetGridItem');
  items.forEach(function(item) {
    item.classList.remove('selected');
  });
  element.classList.add('selected');
  
  // Uppdatera (eller skapa) overlayn för förhandsvisning med den nya mallen
  var overlay = document.getElementById('templateOverlay');
  if (!overlay) {
    overlay = document.createElement("div");
    overlay.id = "templateOverlay";
    overlay.className = "overlayBG";
    document.getElementById('zoomElement').appendChild(overlay);
  }
  overlay.style.backgroundImage = 'url(' + newTemplate + ')';
  
  // Stäng den gamla tavelmallmodalen och dölj overlayn (den används endast för förhandsvisning)
  closeTemplateModal();
  overlay.style.display = 'none';
  
  // Rensa tidigare innehåll och bygg om den draggable containern med den nya tavelmallen
  resetTemplateContent();
  buildDraggableContainer(frameIndex);
  
  // Dölj bakgrundsvyn om den är synlig
  var bgSelection = document.getElementById('backgroundSelection');
  if (bgSelection) {
    bgSelection.style.display = 'none';
  }
  
  // Om både bakgrund och mall är valda, visa kontrollbaren
  if (window.selectedBackground && window.selectedTemplate) {
    showControlBar();
  }
}

function showResetWarningModal(callback) {
  // Visa modal för tavelmall-reset
  var modal = document.getElementById('templateResetModal');
  if (modal) {
    modal.style.display = 'flex';
    
    // Hämta knapparna från modalen – se till att HTML-koden har id:n "btnGoBack" och "btnContinue"
    var cancelBtn = document.getElementById('btnGoBack');
    var confirmBtn = document.getElementById('btnContinue');
    
    // Ta bort eventuella tidigare eventlyssnare för att undvika dubbla anrop
    cancelBtn.onclick = function() {
      modal.style.display = 'none';
      // Stäng även tavelmallmodalen om den är öppen
      closeTemplateModal();
    };
    confirmBtn.onclick = function() {
      modal.style.display = 'none';
      // Rensa tidigare innehåll (så att den nya mallen börjar "fräscht") och anropa callback
      resetTemplateContent();
      callback();
    };
  }
}

function closeTemplateModal() {
  var templateModal = document.getElementById('templateModal');
  if (templateModal) {
    templateModal.style.display = 'none';
  }
}

function resetTemplateContent() {
  // Rensa innehållet från draggable-containern, tavelmallens valda artiklar och ram-behållaren
  var draggableContainer = document.getElementById('draggableContainer');
  if (draggableContainer) {
    draggableContainer.innerHTML = '';
  }
  var chosenArticlesBasket = document.querySelector('.basket .chosenArticles');
  if (chosenArticlesBasket) {
    chosenArticlesBasket.innerHTML = '';
  }
  var basketForFrame = document.querySelector('.basket_for_frame');
  if (basketForFrame) {
    basketForFrame.innerHTML = '';
  }
  // Nollställ priset i controlbaren
  var priceDisplay = document.getElementById('priceAmount');
  if (priceDisplay) {
      priceDisplay.textContent = Shopify.formatMoney(0);
  }
}

// Funktion: Bygg upp draggable containern utifrån Frame_Set[frameIndex]
function buildDraggableContainer(frameIndex) {
  var container = document.getElementById('draggableContainer');
  container.innerHTML = ""; // Rensa tidigare innehåll
  var frames = Frame_Set[frameIndex]; // Använd global Frame_Set-array
  for (let i = 0; i < frames.length; i++) {
    container.insertAdjacentHTML("beforeend", `
      <div 
        data-size="${frames[i].size}" 
        data-position="${frames[i].position}"
        data-item-index="${frames[i].index}" 
        style="top: ${frames[i].top}; left: ${frames[i].left};"
        class="item ${frames[i].positionOriantation === "landscape" ? "landscape" : ""}"
        data-orientation="${frames[i].orientation}"
        data-type="${frames[i].type}"
        onclick="ArticalPicker(this)"
      >
        <div class="inner">${frames[i].size}</div>
      </div>
    `);
  }
  // Visa containern (ta bort 'hidden' om den finns)
  container.classList.remove("hidden");
}

// Funktion för att stänga tavelmallsmodalen
function closeTemplateModal() {
  document.getElementById('templateModal').style.display = 'none';
}

// Om du vill kunna visa tavelmallsmodalen manuellt (t.ex. via en knapp) kan du ha en:
function showTemplateModal() {
  document.getElementById('templateModal').style.display = 'flex';
}

// Lyssna på "wheel"-event på alla element med klassen .presetGrid och omdirigera vertikal scroll till horisontell scroll
document.querySelectorAll('.presetGrid').forEach(function(container) {
  container.addEventListener('wheel', function(event) {
    // Förhindra standard (vertikal scroll)
    event.preventDefault();
    // Justera scrollLeft baserat på hur mycket användaren scrollar vertikalt
    container.scrollLeft += event.deltaY;
  });
});

function showControlBar() {
  // Visa kontrollbaren om den inte redan syns
  let controlBar = document.getElementById('controlBar');
  if (controlBar && controlBar.style.display === 'none') {
    controlBar.style.display = 'flex';
  }
}

function openBackgroundOptions() {
  // Sätt flaggan att detta är ett bakgrundsbyte från kontrollbaren
  isBackgroundChangedFromControl = true;
  // Visa bakgrundsalternativvyn; vi återanvänder samma vy
  document.getElementById('backgroundSelection').style.display = 'block';
  // Om en bakgrund redan är vald, se till att den används i vy:n
  if (window.selectedBackground) {
    document.getElementById('backgroundSelection').style.backgroundImage = 'url(' + window.selectedBackground + ')';
  }
}

function openDesignPicker() {
  hideLegacyFramePicker();
  let templateModal = document.getElementById('templateModal');
  templateModal.style.display = 'flex';          // behåll
  templateModal.classList.add('slide-in-from-right');
}

function openArticlePicker() {
  let articlePickerElem = document.querySelector('.articlePicker');
  if (!articlePickerElem) {

    return;
  }
  // Sätt display och flytta in elementet med slide‑in från höger
  articlePickerElem.style.display = 'flex';
  articlePickerElem.classList.remove('slide-in-from-left');
  articlePickerElem.classList.add('slide-in-from-right');
   articlePickerElem.classList.add('active');
}

function openFramePicker() {
  // Visa ramväljaren om den finns – exempelvis en modal med id "frameModal"
  document.getElementById('frameModal').style.display = 'flex';
}

// En kort sleep-funktion som returnerar ett Promise som löser efter "ms" millisekunder
function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

// Funktion: Försök att automatiskt markera den första tomma draggable itemen
function autoSelectFirstEmptyDraggableItem() {
  const container = document.getElementById("draggableContainer");
  if (!container) {

    return;
  }

  // Hitta första .item som INTE har klassen 'active' eller 'hasArticle'
  const firstEmpty = container.querySelector(".item:not(.active):not(.hasArticle)");
  if (firstEmpty) {
    firstEmpty.classList.add("active");
    // Simulera ett klick på det elementet så att den befintliga logiken körs
    firstEmpty.dispatchEvent(new MouseEvent("click", {
      bubbles: true,
      cancelable: true
    }));

    return true;
  }
  return false;
}

// Asynkron retry-funktion – väntar på att container ska vara redo
async function autoSelectEmptyItemWithRetry(maxRetries = 10, interval = 200) {
  for (let i = 0; i < maxRetries; i++) {
    // Försök att markera
    if (autoSelectFirstEmptyDraggableItem()) {
      return; // Lyckades, avsluta funktionen
    }
    await sleep(interval); // Vänta innan nästa försök
  }

}

// Koppla händelsen till knappen "Byt design"
const btnBytDesign = document.getElementById("changeDesignButton");
if (btnBytDesign) {
  btnBytDesign.addEventListener("click", async function () {
    // Öppna articlePicker-sliden
    OpenSlide("articlePicker", "");
    
    // Vänta en kort stund för att se till att panelen har renderats
    await autoSelectEmptyItemWithRetry(10, 200);
    
    // Om ingen item är markerad (active) – vilket sker om alla items är fyllda –
    // välj ett fallback-item (exempelvis det första itemet) och kör ArticalPicker på det.
    if (!document.querySelector(".articlesContainer .item.active")) {
      let fallbackItem = document.querySelector(".articlesContainer .item");
      if (fallbackItem) {
        fallbackItem.classList.add("active");
        ArticalPicker(fallbackItem);
      }
    }
  });
} else {

}


// Extra capturing-lyssnare på "Byt design"-knappen
document.getElementById("changeDesignButton").addEventListener(
  "click",
  function (e) {
    const articlePicker = document.getElementById("articlePicker");
    // Kolla om articlePicker är aktiv genom att testa om den har klassen "active"
    if (articlePicker && articlePicker.classList.contains("active")) {
      const closeBtn = articlePicker.querySelector(".closePicker");
      if (closeBtn) {
        // Simulera ett klick på stäng-knappen
        closeBtn.click();
        closeFilterModal();
        // Stoppa vidare exekvering av denna händelse (så att btnBytDesign inte öppnar panelen igen)
        e.stopImmediatePropagation();
        e.preventDefault();
      } else {

      }
    }
    // Om panelen inte är aktiv lämnas händelsen oförändrad
  },
  true // Körs i capture-fasen
);



let isBackgroundChangedFromControl = false;

// Lägg till en eventlyssnare så att filuppladdning triggar uploadBackground
document.getElementById('backgroundUpload').addEventListener('change', uploadBackground);

// Event listeners
window.addEventListener("load", adjustLayout);
window.addEventListener("resize", adjustLayout);
window.addEventListener("orientationchange", adjustLayout);

// Initial call
adjustLayout();
